module.exports = __webpack_public_path__ + "img/ep-A.9e4bdb4e.jpg";